<div class="container migrations-container h-100 pb-3">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-breadcrumbs></ziro-breadcrumbs>

    <ziro-datatable
      [class]="'ziro-card'"
      [columns]="columns"
      [rowDataSource]="tableRows"
      [uniqueRowIdentifier]="null"
      [setColumnWidths]="false"
      [dataAutomation]="tableDataAutomation"
      [mainFilterPlaceholder]="'tkey;migrations.ring_central.call_queues.list.table.filter.placeholder' | translate"
      [showCustomAlert]="showCustomAlert"
    >
      <div class="text-center" alert-content>
        {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_1' | translate }}
        <button class="btn btn-link strong" (click)="onRefreshClick()">
          {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_2' | translate }}
        </button>
        {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_3' | translate }}
      </div>
    </ziro-datatable>
  }
</div>
